module.exports = __webpack_public_path__ + "img/144.66b4a7fd.jpg";